export default "__VITE_ASSET__63e369ba__"